import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from "lodash";
import { Acesso } from 'src/app/core/acesso';
import { ToastService } from 'src/app/services/toast/toast.service';
import { MetaAcao } from '../../../../core/meta-acao';
import { MetaAcaoExecutada } from '../../../../core/meta-acao-executada';

@Component({
    selector: 'formulario-acoes-executada-metas-turma',
    templateUrl: './formulario-acoes-executada-metas-turma.component.html',
    styleUrls: ['./formulario-acoes-executada-metas-turma.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioAcoesExecutadaMetasTurmaComponent implements OnInit {

    @Input() metasAcao: MetaAcao[];
    @Input() metas: MetaAcaoExecutada[];
    @Input() meta: MetaAcaoExecutada;
    @Input() index: number;
    @Input() perfilAcesso: Acesso;

    idRandomico = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.metas.splice(this.index, 1);
        this.toastService.showSucesso("Meta removida com sucesso.")
    }

    onValorChangeMeta(registro: any) {
        if (registro && registro.id) {
            const metaJaCadastrado = _.find(this.metas, (metasAcao: MetaAcaoExecutada) => metasAcao.metaAcao?.metaObjetivo?.id === registro.id);
            if (_.isEmpty(metaJaCadastrado)) {
                if (this.metasAcao) {
                    this.metasAcao.forEach(meta => {
                        if (meta.metaObjetivo?.id === registro.id) {
                            this.meta.metaAcao = meta;
                        }
                    });
                }
            } else {
                this.toastService.showAlerta("Meta já adicionada.")
                registro = null;
                this.meta.metaAcao = null;
            }
        }
    }

}
